require('./bootstrap');
require('./hamburger');
// require('./cookie');
require('./slide-to-section');
require('./smooth-scroll');
require('./visible');
// require('./sendmail');


$(document).ready(function() {

    // $(".scroll-to-top").click(function(){
    //     $('html,body').animate({ scrollTop: 0 }, 'slow');
    //     return false;
    // });

    // onScroll();
    // $(document).on("load", onScroll);
    // $(document).on("scroll", onScroll);

});


function onScroll(event) {
    const element = $('h2 span');
    console.log(element);
    element.each(function(i, elem) {
        if ($(elem).visible(true)) {
            var windowHeight = window.innerHeight;
            let width =  100 - ($(elem).offset().top - $(window).scrollTop()) / windowHeight * 100;
            elem.style.setProperty('--width', width * 1.5 + 'vw');
        }
    });
}
